import { render, staticRenderFns } from "./coachVenue.vue?vue&type=template&id=9c47485a&scoped=true&"
import script from "./coachVenue.vue?vue&type=script&lang=js&"
export * from "./coachVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c47485a",
  null
  
)

export default component.exports